//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('discGrpProds', {
//        templateUrl: 'views/components/views/discGrpProds/discGrpProds.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'ttGridFactory', function (stateService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                gridReady: true
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_discgrpprods_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setLoadDataFunction({
//                method: 3112,
//                parameters: {}
//            }).setCustomToolbarButtons([{
//                name: 'discgrpprods_new',
//                text: 'discgrpprods_new',
//                func: () => stateService.go('discgrpprod', { discgrpprod_keyno: '0' }),
//                icon: 'fa-plus',
//                cssClass: 'btn btn-primary im-grid-btn-xs-r',
//                translate: true
//            }]);
            
//            // #endregion VARIABLES & DEFINITIONS
            
//        }]
//    });
//})();
